import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { buildResLinkUrl } from "./utils";

interface LaunchLinkSectionProps {
  launchArgsId: string;
  organizationId: string;
  connectionMethod?: string;
}

/**
 * Reusable component for displaying a Launch Link with copy functionality.
 * Shows the launch_args_id and a button to copy the full ResLink URL.
 */
const LaunchLinkSection: React.FC<LaunchLinkSectionProps> = ({
  launchArgsId,
  organizationId,
  connectionMethod,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const url = buildResLinkUrl(launchArgsId, organizationId, connectionMethod);
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Launch Link
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: "monospace", mb: 1 }}>
        {launchArgsId}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        startIcon={copied ? <CheckCircleIcon color="success" /> : <ContentCopyIcon />}
        onClick={handleCopy}
        sx={{ textTransform: "none", mt: 1 }}
      >
        Copy URL
      </Button>
    </Box>
  );
};

export default LaunchLinkSection;
